module.exports = __webpack_public_path__ + "media/images/survey-followup-0566c51e1cb084089d2b285a2179ec23.svg";